export default __webpack_public_path__ + "484a2ba0f47e0ee9f037cd8bed9869c4.png";